module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/LJVj5v/tc-custom/9781399076128.jpg?1709153588978",
      "alt": "This image is the cover for the book Battle of the Bulge"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Battle of the Bulge\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("This WWII pictorial history presents an in-depth study of Hitler’s epic, final offensive campaign.")]), _c('br'), _c('br'), _vm._v("In December of 1944, nine days before Christmas, Hitler played Germany’s last card on which he staked everything to turn the tables in the West. In this densely illustrated volume, military historian Jean Paul Pallud examines the entire salient with ‘then and now’ photographs. "), _c('br'), _c('br'), _vm._v("Hundreds of miles have been traveled by the author throughout every corner of the battlefield to search out the scenes of past events — every known photograph belonging to combatants, civilians, and in public collections and private sources has been sought or considered. All available film has been examined frame by frame and certain sequences illustrated and analyzed. "), _c('br'), _c('br'), _vm._v("This painstaking process offers a vividly detailed look at the famous battle. A number of classic pictures used — or misused — in depicting the conflict are placed in their true context, often revealing them to be very different from what they seem!\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jean Paul Pallud\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Pen & Sword Limited\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0